<mat-card>
  <mat-card-header
    style="flex-direction: row; justify-content: space-between; align-items: baseline;">
    <mat-card-title><h2>Connections</h2></mat-card-title>
    <button mat-raised-button
            color="accent"
            [matMenuTriggerFor]="addNewCardMenu" i18n>Add New Connection
    </button>
    <mat-menu #addNewCardMenu="matMenu">
      @for (type of connectionTypes$ | async; track type) {
        <button mat-menu-item (click)="onAddConnection(type)">{{ type.name }}</button>
      }
    </mat-menu>
  </mat-card-header>
</mat-card>

<div class="columns">
  <mat-card *ngFor="let connection of connections">
    <mat-card-header>
      <mat-card-title>
        <h3>
          {{ connectionTypes[connection.connectionType] }} - {{connection.host}}
        </h3>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <rsr-badge *ngIf="connection.oauthState" variant="accent" i18n>Waiting for connection</rsr-badge>
      <div *ngIf="!connection.oauthState">
        <div><b>Instance URL:</b> {{ connection.host }}</div>
        <div><b>Public Key:</b> {{ connection.publicKey }}</div>
        <div><b>State:</b>
          <rsr-badge *ngIf="connection.connectivityStatus === 'ok'" variant="primary" i18n>Connected</rsr-badge>
          <rsr-badge *ngIf="connection.connectivityStatus !== 'ok'" variant="warn" i18n>Not connected</rsr-badge>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <ul class="list-inline list-unstyled">
        @let connectionState = getConnectionState(connection);
        <li *ngIf="connectionState === 'registering'">
          <button mat-flat-button color="primary"
                  (click)="onCancelRegistration(connection)"
                  [attr.aria-label]="'Cancel ' + connection.host">
            Cancel
          </button>
        </li>
        <li *ngIf="connectionState === 'registered'">
          <button mat-flat-button color="primary"
                  (click)="onReplace(connection)"
                  [attr.aria-label]="'Replace ' + connection.host">
            Replace
          </button>
        </li>
        <li *ngIf="connectionState === 'registered'">
          <button mat-flat-button color="primary"
                  (click)="onUpdate(connection)"
                  [attr.aria-label]="'Edit ' + connection.host">
            Edit
          </button>
        </li>
        <li *ngIf="connectionState === 'registered'">
          <button mat-flat-button color="warn"
                  (click)="onDelete(connection)"
                  [attr.aria-label]="'Remove ' + connection.host">
            Remove
          </button>
        </li>
      </ul>
    </mat-card-actions>
  </mat-card>
</div>
